import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SkeletonComponent } from '@rma/dashboard/generic/ui/skeleton';

@Component({
  selector: 'rma-my-subscription-is-loading-card',
  imports: [SkeletonComponent],
  templateUrl: './my-subscription-is-loading-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MySubscriptionIsLoadingCardComponent {}
